export class ShippingDetail {
  streetAddress1!: string;
  streetAddress2!: string;
  city!: string;
  state!: string;
  zip!: string;
  country!: string;
  phone!: string;
}
